/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { Layout, Button, Card, Space, Popconfirm } from "antd";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { displayMessage, getAPI } from "../../utils/common";
import { RATE_PLAN_TRUNCATE } from "../../constants/api";
import { ERROR_MSG_TYPE, SUCCESS_MSG_TYPE } from "../../constants/messages";

const { Content } = Layout;
function DBManager() {
  const [loading, setLoading] = useState(false);

  const handleTruncate = async () => {
    setLoading(true);
    getAPI(
      RATE_PLAN_TRUNCATE,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to clear plans");
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content className="p-4 bg-white min-h-screen">
        <Card
          title="DB Manager"
          extra={
            <>
              <Space>
                <Popconfirm
                  title="Truncate the Rate Plan"
                  description="Are you sure you want to clear all rate plans? This action cannot be undone."
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    danger
                    loading={loading}
                    disabled={loading}
                    style={{ color: "#fff" }}
                  >
                    Truncate Plans
                  </Button>
                </Popconfirm>
              </Space>
            </>
          }
        ></Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default DBManager;
